<template>
 <div>
    <!-- table -->
    <pt-gene-lab-order-table :packageType="packageType" :is-lot="true" :params="params" ref="table" :isShowCheckbox="true" @updateSelectedData="updateSelectedData" :show-fields="showFields" :isFromRouter="false" :isAddPageToRouter="false" :showCopy="showCopy">
    </pt-gene-lab-order-table>
 </div>
</template>

<script>
import ptGeneLabOrderTable from 'cps/lab-order/pt-gene-lab-order/pt-gene-lab-order-table/withData'
export default {
  props: {
    status: {
      type: String,
      default: ''
    },
    showFields: {
      type: Array,
      default: () => []
    },
    packageType: {
      type: String,
      default: ''
    }
  },
  computed: {
    showCopy () {
      if (this.status === 'LAB_SAMPLES_RECEIVED') {
        return true
      }
      return false
    }
  },
  data () {
    return {
      params: {
        needActionTaskInfo: true,
        // 分页参数肯定会传默认显示第一页
        pageableParam: { page: 0, size: 10 },
        productIds: [],
        statusTime: [{ startTime: '', endTime: '', orderStatus: 'COMPLETED' }],
        targetStatus: this.status
      }
    }
  },
  components: {
    ptGeneLabOrderTable
  },
  // watch: {
  //   targetStatus (val, old) {
  //     if (val) {
  //       this.reload()
  //     }
  //   }
  // },
  methods: {
    updateSelectedData (datas) {
      this.$emit('updateSelectedData', datas)
    },
    reload () {
      this.$nextTick(() => {
        this.$refs.table.reload(this.params)
      })
    },
    clearSelection () {
      this.$refs.table.clearSelection()
    },
    searchData (data) {
      this.$nextTick(() => {
        this.$refs.table.reload(data, true)
      })
    }
  }
}
</script>

<style>

</style>
